// Voss: koleksiyon ızgarası görünüm yoğunluğu (Zara "GÖRÜNÜM").
// Durum <html data-voss-cols> üzerinde; filtreleme ızgarayı yeniden çizse de korunur.
(() => {
  const KEY = 'voss:grid-cols';
  const root = document.documentElement;
  const mobile = () => window.matchMedia('(max-width: 989px)').matches;
  const allowed = () => (mobile() ? ['1', '2'] : ['2', '4', '6']);
  const sync = () => {
    document.querySelectorAll('[data-voss-cols]').forEach((b) => {
      b.setAttribute('aria-pressed', String(b.dataset.vossCols === root.dataset.vossCols));
    });
  };
  const set = (cols, persist) => {
    if (!allowed().includes(cols)) cols = mobile() ? '2' : '4';
    root.dataset.vossCols = cols;
    root.style.setProperty('--voss-cols', cols);
    if (persist) {
      try { localStorage.setItem(KEY + (mobile() ? ':m' : ':d'), cols); } catch (e) {}
    }
    sync();
  };
  const restore = () => {
    let saved = null;
    try { saved = localStorage.getItem(KEY + (mobile() ? ':m' : ':d')); } catch (e) {}
    set(saved, false);
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-voss-cols]');
    if (btn) set(btn.dataset.vossCols, true);
  });
  document.addEventListener('DOMContentLoaded', () => {
    restore();
    const header = document.querySelector('.section-header');
    if (header) root.style.setProperty('--voss-header-h', header.offsetHeight + 'px');
  });
  window.matchMedia('(max-width: 989px)').addEventListener('change', restore);
  document.addEventListener('shopify:section:load', restore);
})();

// Voss: sepet drawer'ı — %10 indirim hedef çubuğu. Drawer her güncellemede yeniden çizildiği için
// son doluluk oranı saklanır ve yeni çubuk oradan hedefe kayarak dolar.
if (!customElements.get('voss-cart-goal')) {
  let lastPercent = null;
  customElements.define(
    'voss-cart-goal',
    class extends HTMLElement {
      connectedCallback() {
        const fill = this.querySelector('.voss-cart-goal__fill');
        const to = `${this.dataset.percent}%`;
        if (fill && lastPercent !== null && lastPercent !== to) {
          fill.style.setProperty('--voss-goal', lastPercent);
          requestAnimationFrame(() => requestAnimationFrame(() => fill.style.setProperty('--voss-goal', to)));
        }
        lastPercent = to;
      }
    }
  );
}

// Voss: sepet drawer'ı — indirim kodu. Kodlar /cart/update.js "discount" parametresiyle yazılır
// (virgülle ayrılmış tam liste), ardından drawer yeni HTML ile yeniden çizilir.
if (!customElements.get('voss-cart-discount')) {
  customElements.define(
    'voss-cart-discount',
    class extends HTMLElement {
      connectedCallback() {
        this.querySelector('form')?.addEventListener('submit', (e) => {
          e.preventDefault();
          const code = this.querySelector('input').value.trim();
          if (!code) return this.showError('Lütfen bir indirim kodu gir.');
          if (this.codes().some((c) => c.toUpperCase() === code.toUpperCase())) {
            return this.showError('Bu kod zaten uygulandı.');
          }
          this.apply(code);
        });
        this.querySelectorAll('[data-remove]').forEach((btn) => {
          btn.addEventListener('click', () => this.remove(btn.dataset.remove));
        });
      }

      codes() {
        return (this.dataset.codes || '').split(',').filter(Boolean);
      }

      async request(codes) {
        const body = JSON.stringify({
          discount: codes.join(','),
          sections: ['cart-drawer'],
          sections_url: window.location.pathname,
        });
        const res = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
        const cart = await res.json();
        if (!res.ok || cart.errors) throw new Error(cart.description || cart.errors);
        return cart;
      }

      async apply(code) {
        this.setLoading(true);
        try {
          let cart = await this.request([...this.codes(), code]);
          const match = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code.toUpperCase());
          if (match && match.applicable) return this.render(cart);
          // Geçersiz ya da sepete uymayan kod sepette asılı kalmasın.
          cart = await this.request(this.codes());
          this.render(cart, 'Bu kod geçersiz ya da sepetindeki indirimle birlikte kullanılamıyor.', code);
        } catch (e) {
          this.setLoading(false);
          this.showError('Kod uygulanamadı, lütfen tekrar dene.');
        }
      }

      async remove(code) {
        this.setLoading(true);
        try {
          this.render(await this.request(this.codes().filter((c) => c !== code)));
        } catch (e) {
          this.setLoading(false);
          this.showError('Kod kaldırılamadı, lütfen tekrar dene.');
        }
      }

      render(cart, error, value) {
        const html = cart.sections && cart.sections['cart-drawer'];
        const inner = document.querySelector('cart-drawer .drawer__inner');
        const fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
        if (inner && fresh) inner.innerHTML = fresh.innerHTML;
        const el = document.querySelector('voss-cart-discount');
        if (!el) return;
        if (error) {
          el.showError(error);
          el.querySelector('input').value = value || '';
          el.querySelector('input').focus();
        }
      }

      setLoading(on) {
        this.classList.toggle('is-loading', on);
        this.querySelectorAll('button, input').forEach((n) => (n.disabled = on));
      }

      showError(message) {
        const el = this.querySelector('.voss-cart-discount__error');
        if (el) el.textContent = message;
      }
    }
  );
}
